import { BadgeCheck } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

interface VerifiedBadgeProps {
  verified: boolean | null | undefined;
  size?: "sm" | "md";
  showLabel?: boolean;
  className?: string;
}

export function VerifiedBadge({
  verified,
  size = "sm",
  showLabel = true,
  className,
}: VerifiedBadgeProps) {
  if (!verified) return null;
  const iconSize = size === "sm" ? "h-3 w-3" : "h-3.5 w-3.5";
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Badge
          className={cn(
            "bg-emerald-600 hover:bg-emerald-600 text-white border-transparent gap-1",
            !showLabel && "px-1.5",
            className,
          )}
          data-testid="badge-verified"
        >
          <BadgeCheck className={iconSize} />
          {showLabel && <span>Verified</span>}
        </Badge>
      </TooltipTrigger>
      <TooltipContent>
        UEI verified — this workspace controls its company entity at SAM.gov.
      </TooltipContent>
    </Tooltip>
  );
}
